import { Link } from "react-router-dom";

/**
 * Inline upgrade prompt shown when a free-tier limit is hit.
 * Pass the 402 error message and (optionally) a location where the user should return to.
 */
export function UpgradePrompt({ message, onDismiss }) {
  return (
    <div
      data-testid="upgrade-prompt"
      className="mt-3 border border-[#CFA66A]/50 bg-[#CFA66A]/5 p-4 rounded-sm"
    >
      <div className="flex items-start justify-between gap-3">
        <div className="flex-1">
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#CFA66A]">— Free plan limit</p>
          <p className="text-sm text-[#EBE5D9] mt-1">{message}</p>
        </div>
        {onDismiss && (
          <button
            data-testid="upgrade-prompt-dismiss"
            onClick={onDismiss}
            className="text-[#A39A8E] hover:text-[#EBE5D9] w-6 h-6 flex items-center justify-center text-lg leading-none"
            aria-label="Dismiss"
          >×</button>
        )}
      </div>
      <div className="mt-3">
        <Link
          data-testid="upgrade-prompt-cta"
          to="/pricing"
          className="inline-block bg-[#CFA66A] text-[#0F0E0C] font-medium px-4 py-2 rounded-sm hover:bg-[#EBE5D9] transition-colors font-mono text-xs uppercase tracking-widest"
        >
          See Pro plans
        </Link>
      </div>
    </div>
  );
}
